
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Prop, Vue } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import gateway from "@/lib/request/gateway";

@Component({
  components: {}
})
export default class TableDemo extends Vue {
  @Prop({ default: true, type: Boolean }) showBar!: boolean; //是否展示进度条
  @Prop({ default: true, type: Boolean }) beforeCheck!: boolean; //上传前 校验结果
  @Prop({ default: null, type: Function }) beforeUploadCheck!: Function; //上传前 校验结果
  @Prop({ default: "", type: String }) textTip!: string; //提示文案
  loading = false;
  percent = 0;
  get token() {
    return Auth.token;
  }

  created() {
    //
  }
  mounted() {
    //
  }
  //上传前 校验
  beforeUpload(file: File) {
    if (!this.beforeCheck) {
      this.$message.warning("请先填写应聘职位");
      return false;
    }

    if (this.beforeUploadCheck && !this.beforeUploadCheck(file)) {
      return false;
    }
    // const isJPG =
    //   file.type === "image/jpeg" ||
    //   file.type === "image/jpg" ||
    //   file.type === "image/png";
    // if (!isJPG) {
    //   this.$message.error("上传图片只能是 JPG/JPEG/PNG 格式!");
    //   return false;
    // }
    const isLt50M = file.size / 1024 / 1024 < 50;
    if (!isLt50M) {
      this.$message.error("文件过大!");
      return false;
    }
  }
  upload(data: { filename: string; file: File }) {
    const { filename, file } = data;
    this.loading = true;
    //获取上传凭证
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        // const tempUrl = postRes.cdn + "/" + postRes.dir;
        // postRes.cdn = "https://oss.hina.com"; //测试证书过期 用线上的
        // 上传到oss
        const config: any = {
          onUploadProgress: (progressEvent: any) => {
            //progressEvent.loaded:已上传文件大小
            //progressEvent.total:被上传文件的总大小
            this.percent = this.computePer(
              progressEvent.loaded,
              progressEvent.total
            );
          }
        };

        gateway
          .upload(postRes, file, config)
          .then((res: any) => {
            console.log("upload res : ", res);
            this.$emit("uploadSuccess", res); //上传成功后返回
          })
          .finally(() => {
            // this.imageUrl = tempUrl;
            // this.$emit("change", this.imageUrl);
          });
      }
    });
  }
  beforeRemove(file: any, fileList: any) {
    return false;
  }
  computePer(i: number, ii: number) {
    const p = Number((Number(i) / Number(ii)).toFixed(3)) * 100;
    const t = String(p).split(".")[0];
    return Number(t);
  }
  onProgress(event: any, file: any, fileList: any) {
    console.log(event);
  }
}
